import type { Campaign } from 'c-sdk';

/**
 * Update bodies and derived values for the data-status sign-off cell. Extracted from
 * `CampaignSignOffCell`.
 */

export const signOffUpdate = (campaign: Campaign, newState: boolean) =>
    ({ id: campaign.id, sign_off: newState } as Campaign);

/** Flips one `data_status` flag, sending the rest of `data_status` unchanged. */
export const inflightReportSentUpdate = (campaign: Campaign, newState: boolean) =>
    ({
        id: campaign.id,
        data_status: { ...campaign.data_status, inflight_report_sent: newState },
    } as Campaign);

export const pcaReportSentUpdate = (campaign: Campaign, newState: boolean) =>
    ({
        id: campaign.id,
        data_status: { ...campaign.data_status, pca_report_sent: newState },
    } as Campaign);

export const bookingSummaryValidatedToggle = (campaign: Campaign) =>
    ({
        id: campaign.id,
        booking_summary_validated: !campaign.booking_summary_validated,
    } as Campaign);

/** Linear campaigns get the linear PCA; older campaigns store linear as `default`. */
export const isLinearCampaignType = (type: string | null | undefined) =>
    type === 'linear' || type === 'default';

/**
 * Who a PCA / inflight report email goes to by default: each additional contact and the campaign's
 * owner, once each, skipping anyone without an email.
 */
export const pcaReportRecipients = (
    campaign: Pick<Campaign, 'additionalContacts' | 'user'> | null | undefined,
) =>
    Array.from(
        new Set(
            [
                ...(campaign?.additionalContacts ?? []).map(user => user.email),
                campaign?.user?.email,
            ].filter((email): email is string => Boolean(email)),
        ),
    );
